import React from 'react';
import { connect } from 'dva';
import { templateConfig, reduxTemplateCofig } from './config'

import { framework_tool, utils_tool, component_tool } from '@/tool'
let { WizContainer, WizReduxTemplate } = framework_tool;
let { WizNotice, WizBrowserExport } = component_tool;
let { checkStrLength, toChinesNum,Session } = utils_tool;
class Comment extends WizContainer {
  componentName = 'Comment';

  constructor(props) {
    super(props);
    const { history } = props;
    let infoDetail = {};
    if (history.location && history.location.pathname === '/interact/community/invitation/invitationComment') {
      if (history.location && history.location.record) {
        infoDetail = history.location.record;
        Session.set('infoDetail', infoDetail)
      } else {
        infoDetail = Session.get('infoDetail') || {};
      }
    } else if(history.location && (history.location.pathname === '/face/classList/comment' 
        || history.location.pathname === '/perm/classListPerm/comment')) {
      if (history.location && history.location.record) {
        infoDetail = history.location.record;
        Session.set('comment-classInfoDetail', infoDetail)
      } else {
        infoDetail = Session.get('comment-classInfoDetail') || {};
      }
    }
    this.infoDetail = infoDetail;
    this.state = {
    }
  }

  _handleFile(nextProps, nextState, key) {
    let o = nextProps[key]
    let columnDefs = [
      {
        headerName: '',
        width: 30,
        field: 'rowIndex',
        hidden: true,
        suppressMovable: true,
        cellStyle: {
          textAlign: 'center',
          padding: '5px 0',
          color: '#595959',
          backgroundColor: '#f0f0f0',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: '500',
          boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)',
        },
      },
      {
        headerName: '评论内容',
        field: 'content',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
      {
        headerName: '关联实体类型',
        field: 'bizType',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
      {
        headerName: '关联实体',
        field: 'bizContent',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
      {
        headerName: '评论人',
        field: 'commentPerson',
        width: 30,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
      {
        headerName: '评论时间',
        field: 'commentTime',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
      {
        headerName: '评论类型',
        field: 'commentType',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
      {
        headerName: '是否置顶',
        field: 'switchTop',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
      {
        headerName: '是否屏蔽',
        field: 'switchScreen',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
      {
        headerName: '被回复的评论人',
        field: 'replyPerson',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
      {
        headerName: '是否删除',
        field: 'delFlag',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      }
    ]
    if (o['success']) {
      let data = o['data']
      data && data.forEach(d => {
        d.delFlag === 0 ? d.delFlag = '否' : d.delFlag = '是'
      })
      WizBrowserExport({
        title: '评论管理',
        sheetName: '评论管理',
        columns: columnDefs.filter((_, index) => index),
        rows: data,
        filename: '评论管理.xlsx',
      })
      return true
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }
  _handleCMD(nextProps, nextState, key) {
    let o = nextProps[key]
    if (o['success']) {
      wizNotice.success(o['msg'])
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }
  _render() {
    const data = this.infoDetail;
    let commentData = {}
    let btnAccessCheck = true
    let pathname = this.props && this.props.location && this.props.location.pathname
    if(pathname && pathname === '/interact/community/invitation/invitationComment') {
      let bizType = 24 //帖子
      let invitationId =  data.searchProps && data.searchProps.invitation && data.searchProps.invitation.id //帖子ID
      let invitationName =  data.searchProps && data.searchProps.invitation && data.searchProps.invitation.content //帖子内容
      let bizEntity = [{id:invitationId,content:invitationName}]
      let bizId = []
      bizId.push(invitationId)
      commentData = {bizType,bizId,bizEntity}
      btnAccessCheck = data.searchProps && data.searchProps.btnAccessCheck
    } else if(pathname && (pathname === '/face/classList/comment' || pathname === '/perm/classListPerm/comment')) {
      let bizType = 36 //班级
      let classInfoId =  data?.id //班级ID
      let classInfoName =  data?.name //班级名称
      let bizEntity = [{id:classInfoId, name: classInfoName}]
      let bizId = []
      bizId.push(classInfoId)
      commentData = {bizType, bizId, bizEntity}
      btnAccessCheck = false
    }
    let _reduxTemplateCofig = reduxTemplateCofig({
      templateConfig: templateConfig({ commentData: commentData,btnAccessCheck:btnAccessCheck }),
      apiDataFormat: {
        changeTop: this._handleCMD,
        changeScreen: this._handleCMD,
        export: this._handleFile,
      },
      commentData
    })
    return <WizReduxTemplate {..._reduxTemplateCofig} />
  }
}

const mapStateToProps = (state, ownProps) => {
  return {}
};

export default connect(mapStateToProps)(Comment);
